/* DRIPARA — Safe Swiper Init (ready + retry + Shopify events) */
(function(){
  function initRelatedSwipers(){
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper not yet loaded, retrying...');
      setTimeout(initRelatedSwipers, 300);
      return;
    }

    window.relatedSwipers = window.relatedSwipers || [];
    // počisti stare instance
    window.relatedSwipers.forEach(sw => {
      try { sw.destroy(true, true); } catch(e){}
    });
    window.relatedSwipers = [];

    document.querySelectorAll('.related-swiper').forEach(el => {
      const wrapper = el.querySelector('.swiper-wrapper');
      if (!wrapper) {
        // Retry čez 300ms, če wrapper še ni v DOM-u (po ajax reload)
        setTimeout(initRelatedSwipers, 300);
        return;
      }

      const swiper = new Swiper(el, {
        slidesPerView: 1.2,
        spaceBetween: 12,
        freeMode: false,
        grabCursor: true,
        speed: 400,
        preloadImages: false,
        lazy: { loadPrevNext: true },
        keyboard: { enabled: true, onlyInViewport: true },
        mousewheel: { forceToAxis: true, sensitivity: 0.7 },
        navigation: {
          nextEl: el.querySelector('.swiper-button-next') || undefined,
          prevEl: el.querySelector('.swiper-button-prev') || undefined,
          disabledClass: 'swiper-button-disabled',
        },
        breakpoints: {
          0:    { slidesPerView: 1.2, spaceBetween: 8, centeredSlides: true },
          480:  { slidesPerView: 1.5, spaceBetween: 12, centeredSlides: false },
          700:  { slidesPerView: 2.5, spaceBetween: 14 },
          900:  { slidesPerView: 3.2, spaceBetween: 20 },
          1200: { slidesPerView: 3.5, spaceBetween: 24 }
        },
        watchOverflow: true,
        observer: true,
        observeParents: true,
        on: {
          init: function () {
            setTimeout(() => this.update(), 150);
          }
        }
      });
      window.relatedSwipers.push(swiper);
    });
  }

  // 🔒 Varni listenerji (Swiper ready + Shopify section events)
  function bindSwiperInit(){
    const evts = [
      'DOMContentLoaded',
      'shopify:section:load',
      'shopify:cart:change',
      'shopify:product:variant:change',
      'shopify:section:select',
      'shopify:section:deselect',
      'shopify:block:select',
      'shopify:block:deselect',
      'product:variant:change'
    ];
    evts.forEach(e=>document.addEventListener(e, initRelatedSwipers));
  }

  if (typeof Swiper !== 'undefined') {
    // Swiper že obstaja
    bindSwiperInit();
    initRelatedSwipers();
  } else {
    // počakaj, da ga naloži varni loader iz theme.liquid
    window.addEventListener('swiper:ready', ()=>{
      bindSwiperInit();
      initRelatedSwipers();
    }, { once:true });
  }
})();
